export const setQuizzes = "QUIZ/SET_LIST";
export const quizzes = "QUIZ/GET_LIST";

export const setNewQuiz = "QUIZ/SET_NEW_ITEM";
export const setUpdatedQuiz = "QUIZ/SET_UPDATED_ITEM";
export const removeSelectedQuiz = "QUIZ/DELETE_SELECTED_ITEM";

export const setQuizPatterns = "QUIZ/SET_PATTERNS";
export const quizPatterns = "QUIZ/GET_PATTERNS";

export const setQuizAttachmentTypes = "QUIZ/SET_ATTACHMENT_TYPES";
export const quizAttachmentTypes = "QUIZ/GET_ATTACHMENT_TYPES";
